import './index.css'
import { mountCrucialReact } from './crucialReactMount'
import { renderCrucialRoot } from './renderCrucialRoot'
import TestModeApp, { type TestModeConfig } from './TestModeApp'
import { type ThemeMode, withHostTheme } from './themeHandler'

const ThemedTestModeApp = withHostTheme(({ config, theme }: { config: TestModeConfig; theme: ThemeMode }) => (
  <TestModeApp {...config} theme={theme} />
))

mountCrucialReact<TestModeConfig>('TestModeApp', (root, config) => {
  if (!config?.questions) return

  renderCrucialRoot(root, 'TestModeApp', <ThemedTestModeApp config={config} />)
})
